const ee = "EmploymentEquity";

export const GetDisputeResolutionsInformation = `${ee}/DisputeResolutions`;
export const SaveDisputeResolutionsInformation = `${ee}/DisputeResolutions`;